import React from 'react';
import { InputItem } from '@beisen/chaos-ui';
import transLoader from '@beisen/i18n-translation-loader';
import { fixPrecision,formatSymbol } from '../../util/digitHelper';
const defaultTranslation = {
    inputHolder: '点击填写',
    required: '必填',
    searchInputHolder: '点击输入',
    confirm: '确定',
    clear: '清空'
};
class DigitText extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleClearValue = this.handleClearValue.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            inputValue: this.props.text ? this.props.text.replace('%', '') : ''
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            dataMessage: 'digit.dataMessage',
            decimalMessage: 'digit.decimalMessage',
            inputHolder: 'fieldPlaceHolder.inputHolder',
            required: 'common.required',
            searchInputHolder: 'fieldPlaceHolder.searchInputHolder',
            confirm: 'common.confirm',
            clear: 'common.clear'
        }), props.translation);
    }

    isReadOnly() {
        return this.props.cmp_data.cmp_status == 'readonly' || this.props.cmp_data.cmp_status == 'default';
    }

    handleBlur(e) {
        const text = this.state.inputValue.trim().replace(/,/g,'').replace('%','');

        const { precision,containsTrailingZero, formatType } = this.props.cmp_data;

        const fixedPrecisionText = fixPrecision(text,precision,containsTrailingZero);
        let textValue = formatSymbol(fixedPrecisionText,formatType);

        let transmitValue = fixedPrecisionText || '';

        this.setState({ inputValue: textValue });

        if(isNaN(text)) {
            textValue =  text;
            transmitValue = text;
        }

        if(this.props.onBlur) {
            this.props.onBlur({ text: textValue, value: transmitValue });
        }
    }

    handleSubmit() {
        //this.props.handleClosePopUp && this.props.handleClosePopUp();
        this.props.synBizData && this.props.synBizData();
    }

    handleChange(e) {
        this.setState({ inputValue: e.target.value });
    }

    handleClearValue() {
        this.props.handleClosePopUp && this.props.handleClosePopUp();
        this.setState({ inputValue: '' });
        if(this.props.onBlur) {
            this.props.onBlur({ text: '',value: '' });
        }
        this.props.synBizData && this.props.synBizData();
    }

    shouldComponentUpdate(nextprops,nextState) {
         if(nextprops.value != this.props.value ||
          nextprops.text != this.props.text ||
          JSON.stringify(nextState) != JSON.stringify(this.state) ||
          JSON.stringify(nextprops.errorMessage) != JSON.stringify(this.props.errorMessage) ||
          !Immutable.is(Immutable.fromJS(this.props.cmpData),Immutable.fromJS(nextprops.cmpData))
          ) {
            return true;
        }
        return false;
    }

    componentWillReceiveProps(nextProps) {
        //if(nextProps.hasOwnProperty('text') && (nextProps.text != this.props.text || nextProps.value != this.props.value)) {
            this.setState({ inputValue: nextProps.text ? nextProps.text.replace('%', '') : '' });
        //0 }
    }

    render() {
        //if(this.props.formType === 'detailForm' && !this.props.isInterval) => showfield
        const { className, desc, errorMessage, ...other } = this.props;
        const errMsg = errorMessage && errorMessage.message;
        const symbol = this.props.cmp_data.formatType == 'percentageSymbol' || this.props.cmp_data.formatType == 'thousandPercentageSymbol' ? '(%)' : '';
        return (
                <InputItem
                    {...other}
                    cls={className}
                    label={this.props.label + symbol}
                    value={this.state.inputValue}
                    type="text"
                    stateClass={this.props.stateClass}
                    isReadOnly={this.props.isReadOnly}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    errorMsg={errMsg}
                    desc={desc}
                    popType={this.props.pop_type}
                    onSubmit={this.handleSubmit}
                    onClearValue={this.handleClearValue}
                    translation={this.translation}
                />);
    }
}

DigitText.defaultProps = {
    cmp_data: {}
};
export default DigitText;



// WEBPACK FOOTER //
// ./src/components/Field_Components/DigitText/DigitText.js